import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CommercialProperty } from '../../models/response-commercial-data';

@Component({
  selector: 'app-response-commercial-data',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-commercial-data.component.html'
})
export class ResponseCommercialDataComponent {
  @Input() response: CommercialProperty;
}
